import type { Distance, Pixel, Rectangle } from "@pdfking/math"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import { RecordMap } from "@pdfking/tfunc"

export const ConvertRectangle = <T extends Rectangle<Pixel>>(
  options: PdfEngineOptions,
  rect: T
): { [K in keyof T]: Distance } =>
  RecordMap(v => ((v as number) / options.unit_to_px) as Distance, rect)
